import { isFunction } from "@/utils";
import * as S from "./styles";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { colors } from "@/theme";

export type CounterProps = {
  value?: number;
  onChange?: (value: number) => void;
};

const Counter: React.FC<CounterProps> = ({
  value = undefined,
  onChange = undefined,
}) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const onClick = (operation: number) => {
    if (isNaN(value as number) || !isFunction(onChange)) {
      return;
    }
    // If trying to decrement from 1, show dialog instead of removing immediately
    if (operation === -1 && value === 1) {
      setIsDeleteDialogOpen(true);
      return;
    }
    onChange?.((value as number) + operation);
  };

  const handleDelete = () => {
    setIsDeleteDialogOpen(false);
    if (isFunction(onChange)) {
      onChange?.(0); // Remove item
    }
  };

  return (
    <>
      <S.CounterContainer>
        <S.CounterRemove onClick={() => onClick(-1)}>
          {value === 1 ? (
            <DeleteOutlineIcon sx={{ fontSize: 24, color: 'black' }} />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 6 2"
              fill="none"
            >
              <line
                x1="0.375"
                y1="0.897461"
                x2="5.625"
                y2="0.897461"
                stroke="black"
                strokeWidth="0.75"
                strokeLinecap="round"
              />
            </svg>
          )}
        </S.CounterRemove>
        <S.CounterBody>{value}</S.CounterBody>
        <S.CounterAdd onClick={() => onClick(1)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 6 6"
            fill="none"
          >
            <line
              x1="2.89771"
              y1="5.625"
              x2="2.89771"
              y2="0.375"
              stroke="black"
              strokeWidth="0.75"
              strokeLinecap="round"
            />
            <line
              x1="0.375"
              y1="2.89746"
              x2="5.625"
              y2="2.89746"
              stroke="black"
              strokeWidth="0.75"
              strokeLinecap="round"
            />
          </svg>
        </S.CounterAdd>
      </S.CounterContainer>
      <Dialog
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 0,
            minWidth: 350,
            fontFamily: "PF DIN Text Pro",
          },
        }}
      >
        <DialogContent sx={{ textAlign: "center", pt: 4, pb: 2 }}>
          <Typography sx={{ fontSize: 20, fontWeight: 500, mb: 2, fontFamily: "PF DIN Text Pro" }}>
            Are you sure you want to delete this item?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <Button
            variant="outlined"
            onClick={() => setIsDeleteDialogOpen(false)}
            sx={{
              color: colors.neutralGrey800,
              borderColor: colors.neutralGrey800,
              minWidth: 100,
              borderRadius: 1.5,
              
              fontWeight: 500,
              fontSize: 18,
              textTransform: "none",
              mr: 2,
              fontFamily: "PF DIN Text Pro",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleDelete}
            sx={{
              minWidth: 100,
              borderRadius: 1.5,
              fontWeight: 400,
              fontSize: 18,
              textTransform: "none",
              background: "#E53912",
              color: "#fff",
              ":hover": { background: "#b71c00" },
              fontFamily: "PF DIN Text Pro",
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Counter;
